'use strict';

var lib = require('./lib-75591456.js');
var icon = require('./icon-e3ab87ed.js');

var SORT = 'M10 5L7 8H9.25V13.25H10.75V8H13L10 5ZM15.25 15.5V10.25H13.75V15.5H11.5L14.5 18.5L17.5 15.5H15.25Z';
var IconSort = lib.variant('IconSort', icon.Icon, {
    path: SORT,
});

exports.IconSort = IconSort;
//# sourceMappingURL=index-586a8007.js.map
